import { tickerItems } from "@/mocks/home";

export default function Ticker() {
  const loop = [...tickerItems, ...tickerItems];
  return (
    <div className="relative bg-secondary-900 text-background-50">
      <div className="flex items-center gap-4 px-4 md:px-10 h-11">
        <span className="hidden sm:inline-flex items-center gap-1.5 text-xs font-medium text-accent-300 shrink-0">
          <i className="ri-megaphone-line" />
          站内公告
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker whitespace-nowrap">
            {loop.map((item, index) => (
              <span key={index} className="flex items-center text-xs md:text-sm text-background-100">
                <span className="w-1 h-1 rounded-full bg-accent-400 mx-4" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}